<!--
     <FieldIndicatorTracking>
-->

<template>
  <div class="field-it">
    <div
      :class="'field-it-metric' + (short ? ' field-it-short' : '' )"
      v-for="metric in (field.props.metrics || [])"
      :key="metric.id"
    >
      <label>{{ metric.name }}</label>
      <span v-if="field.value">{{ field.value[metric.id]}}</span>
    </div>
  </div>
</template>

<style lang="scss">
 .field-it {
   display: flex;
   flex-direction: column;
   flex-wrap: wrap;
 }

 .field-it-metric {
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   min-width: 128px;
   max-width: 100%;
   gap: 10px;
   justify-content: space-between;
   border-style: solid;
   border-color: $primary;
   border-width: 0px 0px 1px 0px;
   padding: 4px;
 }

 .field-it-metric > label {
   display: block;
   /* color: $primary; */
   font-weight: bold;
 }

 .field-it-metric > span {
   display: block;
   min-width: 32px;
   text-align: right;
 }

 .field-it-short {
   flex-direction: row;
   border-style: none;
   padding: 0px;
 }
 .field-it-short > label {
   font-weight: bold;
 }
 .field-it-short > span {

 }
</style>

<script>
 export default {
   name: 'FieldIndicatorTracking',
   
   props: {
     field: {required: true},
     short: {type: Boolean, default: false},
   },

   computed: {
     representation() {
       const value = ''+(this.field || {}).readable_text();
       return value;
     },

     color() {
       return (this.field || {}).dot_color()
     }
   },
 };
</script>
